import { SelectOption } from '@common/types/common';
import { Roles } from '@common/types/user';
import { api } from '@services/api';

const userRolesApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getRoles: builder.query<SelectOption<Roles>[], void>({
            query: () => 'public/user-roles/',
            providesTags: ['Roles'],
            transformResponse: (response: { key: Roles; name: string }[]) =>
                response.map((x) => ({
                    label: x.name,
                    value: x.key,
                })),
        }),
    }),
});

export const { useGetRolesQuery } = userRolesApi;
export default userRolesApi;
